import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  Text,
  ActivityIndicator,
  TouchableOpacity,
  TextInput,
  Modal,
} from "react-native";
import { useSelector } from "react-redux";
import { styles } from "../../style/FoundryStyle.js";
import { SCREEN_IDS } from "../FullComponent.js";
import { typeConnect } from "../../constants/Constants.js";
import { translateText } from "../../translations/translationService";
import {
  fullDataRepairPiece,
  fullDataPiece,
} from "../../services/ConnectDataBase.js";
import { Search as SearchIcon } from "@mui/icons-material";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useDispatch } from "react-redux";
import { getArrayInfoDataUpdate } from "../../services/Functions";
import { updateInfoData } from "../../redux/reducers";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { BRAND_COLORS, BACKGROUND_COLORS, TEXT_COLORS, FUNDICION_STATUS_COLORS } from "../../style/colors.js";

// Configuración de skeletons de carga
const SKELETON_CONFIG = {
  rows: 5,              // Número de filas de skeletons
  height: 20,           // Altura de los skeletons en px
  widthLabel: "100%",   // Ancho del skeleton de etiqueta (cliente)
  widthValue: "100%",   // Ancho del skeleton de valor (datos)
};

const RepairStatus = ({ navigation }) => {
  const screenName = "RepairStatusScreen";
  const lang = useSelector((state) => state.lang.value);
  const currentScreenId = SCREEN_IDS.PIECES_REPAIRS;
  const [datosReparaciones, setDatosReparaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ cliente: "", mos: [] });
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [searchModal, setSearchModal] = useState(false);

  const [itemRetraso, setItemRetraso] = useState({});
  const [itemUno, setItemUno] = useState({});
  const [itemDos, setItemDos] = useState({});
  const [itemTres, setItemTres] = useState({});
  const [itemCuatro, setItemCuatro] = useState({});
  const [itemCinco, setItemCinco] = useState({});
  const [itemSeis, setItemSeis] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    const processData = async () => {
      try {
        setIsLoading(true);
        const dataOk = await fullDataRepairPiece(
          currentScreenId,
          typeConnect[0]
        );
        if (dataOk) {
          const groupedData = calculateData(dataOk);
          setDatosReparaciones(Object.values(groupedData));
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };

    processData();
  }, []);

  const getCellStyle = (value, column) => {
    let backgroundColor, color, fontWeight;
    if (value > 0) {
      if (column === "retraso") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_RETRASO;
        color = TEXT_COLORS.LIGHT;
        fontWeight = "normal";
      } else if (column === "uno") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_VERY_HIGH;
        color = BACKGROUND_COLORS.TABLE_ROW_EVEN;
        fontWeight = "normal";
      } else if (column === "dos") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_HIGH;
        color = TEXT_COLORS.DARK;
        fontWeight = "normal";
      } else if (column === "tres") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_MEDIUM_HIGH;
        color = TEXT_COLORS.DARK;
        fontWeight = "normal";
      } else if (column === "cuatro") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_MEDIUM;
        color = TEXT_COLORS.DARK;
        fontWeight = "normal";
      } else if (column === "cinco") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_LOW;
        color = TEXT_COLORS.DARK;
        fontWeight = "normal";
      } else if (column === "seis") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_VERY_LOW;
        color = TEXT_COLORS.DARK;
        fontWeight = "normal";
      } else if (column === "total") {
        backgroundColor = FUNDICION_STATUS_COLORS.STATUS_VERY_LOW;
        color = TEXT_COLORS.DARK;
        fontWeight = "normal";
      }
    } else {
      backgroundColor = "transparent";
      color = TEXT_COLORS.DARK;
      fontWeight = "normal";
    }
    return { backgroundColor, color, fontWeight };
  };

  const calculateData = (data) => {
    const today = new Date();
    let newItemRetraso = {};
    let newItemUno = {};
    let newItemDos = {};
    let newItemTres = {};
    let newItemCuatro = {};
    let newItemCinco = {};
    let newItemSeis = {};

    const groupedData = data.reduce((acc, item) => {
      const cliente = item.cliente || "Desconocido";
      const entrega = new Date(item.fechaentrega.date);
      const diffTime = entrega.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 3600 * 24));
      let cantidad = parseFloat(item.cantidad);

      if (!acc[cliente]) {
        acc[cliente] = {
          nombreCliente: cliente,
          total: 0,
          retraso: 0,
          uno: 0,
          dos: 0,
          tres: 0,
          cuatro: 0,
          cinco: 0,
          seis: 0,
        };
        newItemRetraso[cliente] = [];
        newItemUno[cliente] = [];
        newItemDos[cliente] = [];
        newItemTres[cliente] = [];
        newItemCuatro[cliente] = [];
        newItemCinco[cliente] = [];
        newItemSeis[cliente] = [];
      }

      acc[cliente].total += cantidad;

      if (diffDays <= 0) {
        acc[cliente].retraso += cantidad;
        newItemRetraso[cliente].push(item.mo);
      } else if (diffDays <= 1) {
        acc[cliente].uno += cantidad;
        newItemUno[cliente].push(item.mo);
      } else if (diffDays <= 2) {
        acc[cliente].dos += cantidad;
        newItemDos[cliente].push(item.mo);
      } else if (diffDays <= 3) {
        acc[cliente].tres += cantidad;
        newItemTres[cliente].push(item.mo);
      } else if (diffDays <= 4) {
        acc[cliente].cuatro += cantidad;
        newItemCuatro[cliente].push(item.mo);
      } else if (diffDays <= 5) {
        acc[cliente].cinco += cantidad;
        newItemCinco[cliente].push(item.mo);
      } else if (diffDays <= 6) {
        acc[cliente].seis += cantidad;
        newItemSeis[cliente].push(item.mo);
      }

      return acc;
    }, {});

    setItemRetraso(newItemRetraso);
    setItemUno(newItemUno);
    setItemDos(newItemDos);
    setItemTres(newItemTres);
    setItemCuatro(newItemCuatro);
    setItemCinco(newItemCinco);
    setItemSeis(newItemSeis);

    return groupedData;
  };

  const handleCloseSearchModal = () => {
    setSearchTerm("");
    setSearchResult(null);
    setSearchModal(false);
  };

  const handleCellPress = (cliente, column) => {
    let mos = [];
    switch (column) {
      case "retraso":
        mos = itemRetraso[cliente] || [];
        break;
      case "uno":
        mos = itemUno[cliente] || [];
        break;
      case "dos":
        mos = itemDos[cliente] || [];
        break;
      case "tres":
        mos = itemTres[cliente] || [];
        break;
      case "cuatro":
        mos = itemCuatro[cliente] || [];
        break;
      case "cinco":
        mos = itemCinco[cliente] || [];
        break;
      case "seis":
        mos = itemSeis[cliente] || [];
        break;
      default:
        break;
    }

    setModalData({ cliente, mos });
    setShowModal(true);
  };

  const handleSearch = () => {
    let found = false;
    let result = null;

    for (const cliente in itemRetraso) {
      if (itemRetraso[cliente].includes(searchTerm)) {
        result = { cliente, column: "retraso" };
        found = true;
        break;
      }
    }

    if (!found) {
      for (const cliente in itemUno) {
        if (itemUno[cliente].includes(searchTerm)) {
          result = { cliente, column: "uno" };
          found = true;
          break;
        }
      }
    }

    if (!found) {
      for (const cliente in itemDos) {
        if (itemDos[cliente].includes(searchTerm)) {
          result = { cliente, column: "dos" };
          found = true;
          break;
        }
      }
    }

    if (!found) {
      for (const cliente in itemTres) {
        if (itemTres[cliente].includes(searchTerm)) {
          result = { cliente, column: "tres" };
          found = true;
          break;
        }
      }
    }

    if (!found) {
      for (const cliente in itemCuatro) {
        if (itemCuatro[cliente].includes(searchTerm)) {
          result = { cliente, column: "cuatro" };
          found = true;
          break;
        }
      }
    }

    if (!found) {
      for (const cliente in itemCinco) {
        if (itemCinco[cliente].includes(searchTerm)) {
          result = { cliente, column: "cinco" };
          found = true;
          break;
        }
      }
    }

    if (!found) {
      for (const cliente in itemSeis) {
        if (itemSeis[cliente].includes(searchTerm)) {
          result = { cliente, column: "seis" };
          found = true;
          break;
        }
      }
    }

    setSearchResult(result);
  };

 
  const validateData = async (code) => {
    if (!code) {
      return; // Si el código está vacío, no ejecutar la consulta
    }
    try {
      const dataOk = await fullDataPiece(code, 2); // Aquí suponemos que `code` es `mo`
      if (dataOk) {
        const infoData = getArrayInfoDataUpdate(dataOk);

        dispatch(updateInfoData(infoData));
        return dataOk;
      }
    } catch (error) {
      // Manejo de errores
      console.error(error);
    }
  };

  const handleSubmitCode = async (code) => {
    try {
      const fullData = await validateData(code);

      if (code) {
        if (fullData && fullData.mo) {
          setShowModal(false);
          navigation.navigate("Info", { data: fullData });
        } else {
          console.log("La propiedad 'mo' no existe en fullData.");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <View style={[styles.containerRepairScreen, { marginLeft: 25, marginRight: 25}]}>
      <View style={styles.tableRepairScreen}>
        <TableContainer
          component={Paper}
          style={{
            ...styles.tableContainerRepairScreen,
            // height: "calc(110% - 20px)",
            maxHeight: "75vh",
       
          }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {/* Celda para el ícono de búsqueda */}
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <TouchableOpacity
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: TEXT_COLORS.LIGHT,
                    }}
                    onPress={() => setSearchModal(true)}>
                    <SearchIcon style={{ fontSize: 18, color: TEXT_COLORS.LIGHT }} />
                  </TouchableOpacity>
                </TableCell>
                {/* Encabezados de la tabla */}
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    {translateText("Cliente", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    {translateText("En retraso", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    1 {translateText("día", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    2 {translateText("días", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    3 {translateText("días", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    4 {translateText("días", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    5 {translateText("días", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    6 {translateText("días", lang)}
                  </Text>
                </TableCell>
                <TableCell
                  style={{
                    ...styles.headerCellRepairScreen,
                    backgroundColor: BACKGROUND_COLORS.DARK,
                    borderBottom: `1px solid rgba(255,255,255,0.1)`,
                    padding: "2px 4px",
                    textAlign: "center",
                  }}>
                  <Text style={{ fontWeight: "500", color: TEXT_COLORS.LIGHT, fontSize: 13 }}>
                    {translateText("Total", lang)}
                  </Text>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <>
                  {[...Array(SKELETON_CONFIG.rows)].map((_, i) => (
                    <TableRow
                      key={i}
                      style={{
                        backgroundColor: i % 2 === 0 ? "#ffffff" : "#f5f5f5",
                      }}>
                      {/* Columna vacía para alinear con el ícono de búsqueda */}
                      <TableCell
                        style={{
                          padding: "2px 4px",
                          backgroundColor: i % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          borderBottom: `1px solid rgba(0,0,0,0.08)`,
                        }}
                      />
                      {/* Columna del cliente */}
                      <TableCell
                        style={{
                          padding: "2px 8px",
                          backgroundColor: i % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          borderBottom: `1px solid rgba(0,0,0,0.08)`,
                        }}>
                        <Skeleton variant="text" width={SKELETON_CONFIG.widthLabel} height={SKELETON_CONFIG.height} />
                      </TableCell>
                      {/* 7 columnas de datos */}
                      {[...Array(7)].map((_, j) => (
                        <TableCell
                          key={j}
                          style={{
                            padding: "2px 4px",
                            textAlign: "center",
                            backgroundColor: i % 2 === 0 ? "#ffffff" : "#f5f5f5",
                            borderBottom: `1px solid rgba(0,0,0,0.08)`,
                          }}>
                          <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                        </TableCell>
                      ))}
                      {/* Columna del total */}
                      <TableCell
                        style={{
                          padding: "2px 4px",
                          textAlign: "center",
                          backgroundColor: i % 2 === 0 ? "#ffffff" : "#f5f5f5",
                          borderBottom: `1px solid rgba(0,0,0,0.08)`,
                        }}>
                        <Skeleton variant="text" width={SKELETON_CONFIG.widthValue} height={SKELETON_CONFIG.height} />
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                datosReparaciones.map((item, index) => (
                  <TableRow 
                    key={index} 
                    style={{
                      ...styles.rowRepairScreen,
                      backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                    }}>
                    {/* Celda vacía para alinear con el ícono de búsqueda */}
                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "2px 4px",
                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                        borderBottom: `1px solid rgba(0,0,0,0.08)`,
                      }}></TableCell>
                    {/* Celda del cliente */}
                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "2px 8px",
                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                        borderBottom: `1px solid rgba(0,0,0,0.08)`,
                      }}>
                      <Text style={{ 
                        fontWeight: "500", 
                        color: "#174045", 
                        fontSize: 13 
                      }}>
                        {item.nombreCliente ? item.nombreCliente : "-"}
                      </Text>
                    </TableCell>
                    {/* Celdas de datos con estilos aplicados */}
                    {[
                      "retraso",
                      "uno",
                      "dos",
                      "tres",
                      "cuatro",
                      "cinco",
                      "seis",
                    ].map((column) => {
                      const cellStyle = getCellStyle(item[column], column);
                      const baseBg = index % 2 === 0 ? "#ffffff" : "#f5f5f5";
                      return (
                        <TableCell
                          key={column}
                          style={{
                            ...styles.cellRepairScreen,
                            padding: "2px 4px",
                            textAlign: "center",
                            backgroundColor: item[column] > 0 
                              ? cellStyle.backgroundColor 
                              : baseBg,
                            borderBottom: `1px solid rgba(0,0,0,0.08)`,
                          }}>
                          <TouchableOpacity
                            onPress={() =>
                              handleCellPress(item.nombreCliente, column)
                            }>
                            <Text
                              style={{
                                color: item[column] > 0 
                                  ? cellStyle.color 
                                  : "#000000",
                                fontWeight: cellStyle.fontWeight,
                                fontSize: 13,
                              }}>
                              {item[column]}
                            </Text>
                          </TouchableOpacity>
                        </TableCell>
                      );
                    })}
                    {/* Celda del total */}
                    <TableCell
                      style={{
                        ...styles.cellRepairScreen,
                        padding: "2px 4px",
                        textAlign: "center",
                        backgroundColor: item.total > 0 
                          ? getCellStyle(item.total, "total").backgroundColor 
                          : (index % 2 === 0 ? "#ffffff" : "#f5f5f5"),
                        borderBottom: `1px solid rgba(0,0,0,0.08)`,
                      }}>
                      <Text
                        style={{
                          color: item.total > 0 
                            ? getCellStyle(item.total, "total").color 
                            : "#000000",
                          fontWeight: getCellStyle(item.total, "total")
                            .fontWeight || "600",
                          fontSize: 13,
                        }}>
                        {item.total}
                      </Text>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </View>
      {/* Modal de detalles de MO */}
      <Modal
        animationType='fade'
        transparent={true}
        visible={showModal}
        onRequestClose={() => setShowModal(false)}>
        <View style={styles.modalContainer}>
          <View
            style={{
              maxHeight: "40vh",
              minHeight: "40vh",
              minWidth: "50vh",
              backgroundColor: "#ffffff",
              borderRadius: 6,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 5,
              borderWidth: 1,
              borderColor: "#9bb1bb",
              overflow: "hidden",
            }}>
            {/* Header */}
            <View
              style={{
                backgroundColor: "#f5f5f5",
                paddingHorizontal: 12,
                paddingVertical: 10,
                borderBottomWidth: 1,
                borderBottomColor: "#9bb1bb",
              }}>
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "600",
                  color: "#174045",
                  textAlign: "center",
                  textTransform: "uppercase",
                }}>
                {modalData.cliente}
              </Text>
            </View>
            {/* Content */}
            <ScrollView
              style={{
                flex: 1,
                backgroundColor: "white",
              }}>
              <View style={styles.column}>
                {modalData.mos.length > 0 ? (
                  modalData.mos.map((mo, index) => (
                    <TouchableOpacity
                      key={index}
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        paddingVertical: 6,
                        paddingHorizontal: 12,
                        borderBottomWidth: 1,
                        borderBottomColor: "#9bb1bb",
                        backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                      }}
                      onPress={() => handleSubmitCode(mo)}>
                      <Text
                        style={{
                          fontSize: 13,
                          fontWeight: "500",
                          color: "#174045",
                          fontFamily: "monospace",
                        }}>
                        {mo}
                      </Text>
                    </TouchableOpacity>
                  ))
                ) : (
                  <View style={{ padding: 20, alignItems: "center" }}>
                    <Text
                      style={{
                        fontSize: 13,
                        fontWeight: "500",
                        color: "#666",
                        textAlign: "center",
                      }}>
                      {translateText("No hay MO", lang)}
                    </Text>
                  </View>
                )}
              </View>
            </ScrollView>
            {/* Footer */}
            <TouchableOpacity
              style={{
                backgroundColor: "#174045",
                paddingVertical: 8,
                paddingHorizontal: 16,
                alignItems: "center",
                borderTopWidth: 1,
                borderTopColor: "#9bb1bb",
              }}
              onPress={() => setShowModal(false)}>
              <Text
                style={{
                  color: "#ffffff",
                  fontWeight: "500",
                  fontSize: 12,
                  textTransform: "uppercase",
                }}>
                Cerrar
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* Modal de búsqueda */}
      <Modal
        animationType='fade'
        transparent={true}
        visible={searchModal}
        onRequestClose={() => setSearchModal(false)}>
        <View style={styles.modalContainer}>
          <View
            style={{
              maxHeight: "45vh",
              minWidth: "50vh",
              backgroundColor: "#ffffff",
              borderRadius: 6,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 5,
              borderWidth: 1,
              borderColor: "#9bb1bb",
              overflow: "hidden",
            }}>
            {/* Header */}
            <View
              style={{
                backgroundColor: "#f5f5f5",
                paddingHorizontal: 12,
                paddingVertical: 10,
                borderBottomWidth: 1,
                borderBottomColor: "#9bb1bb",
              }}>
              <Text
                style={{
                  fontSize: 14,
                  fontWeight: "600",
                  color: "#174045",
                  textAlign: "center",
                }}>
                {translateText("Buscar MO", lang)}
              </Text>
            </View>
            {/* Content */}
            <View style={{ padding: 12 }}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 12,
                }}>
                <TextInput
                  style={{
                    flex: 1,
                    backgroundColor: "#ffffff",
                    borderColor: "#9bb1bb",
                    borderWidth: 1,
                    paddingHorizontal: 8,
                    paddingVertical: 6,
                    fontSize: 12,
                    borderRadius: 4,
                    color: "#174045",
                    fontFamily: "monospace",
                  }}
                  placeholder={translateText("Introduzca MO", lang)}
                  placeholderTextColor='#999'
                  value={searchTerm}
                  onChangeText={setSearchTerm}
                />
                <TouchableOpacity
                  style={{
                    backgroundColor: "#174045",
                    borderRadius: 4,
                    padding: 6,
                    marginLeft: 8,
                  }}
                  onPress={handleSearch}>
                  <MaterialCommunityIcons
                    name='magnify'
                    size={18}
                    color="#ffffff"
                  />
                </TouchableOpacity>
              </View>
              {searchResult ? (
                <View
                  style={{
                    backgroundColor: "#f5f5f5",
                    padding: 10,
                    borderRadius: 4,
                    marginBottom: 12,
                    borderWidth: 1,
                    borderColor: "#9bb1bb",
                  }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "500",
                      color: "#174045",
                      marginBottom: 4,
                    }}>
                    {translateText("MO", lang)}: {searchTerm}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "500",
                      color: "#174045",
                      marginBottom: 4,
                    }}>
                    {translateText("Cliente", lang)}: {searchResult.cliente}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontWeight: "500",
                      color: "#666",
                    }}>
                    {searchResult.column !== "retraso"
                      ? `Restante: ${searchResult.column} días`
                      : "Estado: Retrasado"}
                  </Text>
                </View>
              ) : (
                searchTerm && (
                  <View
                    style={{
                      padding: 10,
                      alignItems: "center",
                      marginBottom: 12,
                    }}>
                    <Text
                      style={{
                        textAlign: "center",
                        color: "#999",
                        fontSize: 12,
                      }}>
                      No se encontraron resultados.
                    </Text>
                  </View>
                )
              )}
              {/* Footer */}
              <TouchableOpacity
                style={{
                  backgroundColor: "#174045",
                  paddingVertical: 8,
                  paddingHorizontal: 16,
                  borderRadius: 4,
                  alignItems: "center",
                }}
                onPress={handleCloseSearchModal}>
                <Text
                  style={{
                    color: "#ffffff",
                    fontWeight: "500",
                    fontSize: 12,
                    textTransform: "uppercase",
                  }}>
                  {translateText("Cerrar", lang)}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default RepairStatus;
